<template>
  <div class="top_title">
    <div class="top_nav">
      <div class="logo">
        <router-link to="/home">
          <div class="logo-style">
            <img src="../assets/image/homePage/maintop/logo.png" alt="" />
            <!-- <span>
          </span> -->
            <!-- <span class="logotop-main">
<span>成都北鸣</span>
<span>B E I M I N G</span>
          </span> -->
          </div>
        </router-link>
      </div>
      <ul class="navigation">
        <li :class="classname == 'home' ? 'home-select' : ''">
          <router-link to="/home"
            >首页
            <div class="li-linehome"></div
          ></router-link>
        </li>
        <li :class="classname == 'product' ? 'home-select' : ''">
          <router-link to="/product"
            >产品介绍
            <div class="li-line"></div
          ></router-link>
        </li>
        
        <li
          :class="
            classname == 'businessintroduce' ? 'home-select' : 'home-noselect'
          "
        >
          业务介绍
          <div class="li-line"></div>
          <div class="ol-style">
            <ol
              :class="
                childclassname == 'moneyinvolved' ? 'ol-main' : 'home-noselect'
              "
            >
              <router-link to="/moneyinvolved">
                <span class="olmian-style"> 案件配侦 </span>
              </router-link>
            </ol>
            <ol
              :class="
                childclassname == 'dataasset' ? 'ol-main' : 'home-noselect'
              "
            >
              <router-link to="/dataasset">
                <span class="olmian-style">资产挽损</span>
              </router-link>
            </ol>
            <ol
              :class="
                childclassname == 'serviceprocess' ? 'ol-main' : 'home-noselect'
              "
            >
              <router-link to="/serviceprocess">
                <span class="olmian-style">安全审计</span>
              </router-link>
            </ol>

            <ol
              :class="
                childclassname == 'onchainatm' ? 'ol-main' : 'home-noselect'
              "
            >
              <router-link to="/onchainatm">
                <span class="olmian-style">链上AML</span>
              </router-link>
            </ol>

            <ol
              :class="
                childclassname == 'businessintroducechild'
                  ? 'ol-main'
                  : 'home-noselect'
              "
            >
              <router-link to="/businessintroduce">
                <span class="olmian-style">合规处置</span>
              </router-link>
            </ol>
          </div>
        </li>
        <li :class="classname == 'security' ? 'home-select' : ''">
          <router-link to="/security"
            >图链安全
            <div class="li-line"></div
          ></router-link>
        </li>
        <li
          style="padding-right: 12px"
          :class="classname == 'aboutus' ? 'home-select' : ''"
        >
          <router-link to="/aboutus"
            >关于我们
            <div class="li-line"></div
          ></router-link>
          <!-- <div class="ol-style">
            <ol><router-link to="/aboutus">公司介绍</router-link></ol>
            <ol> <router-link to="/technical" :class="childclassname == 'technical' ? 'home-select' : ''">技术能力</router-link></ol>



</div> -->
        </li>
        <li>
          <div id="navfree" class="nav-free" @click="navfreefn">
            免费试用
            <div class="navfree-mask" v-show="isfree">
              <!-- <span class="close-style" @click="closenavfreefn">x</span> -->

              <div class="mask-content">
                <img
                  src="@/assets/image/homePage/mainbottom/weixinimg.png"
                  alt=""
                />
                <span>添加上方微信客服可开通产品免费试用</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["classname", "childclassname"],
  data() {
    return {
      isfree: false,
    };
  },
  methods: {
    navfreefn() {
      this.isfree = true;
    },
    closenavfreefn() {
      console.log(11);
      console.log(this.isfree);
      setTimeout(() => {
        this.isfree = !this.isfree;
      }, 100);
    },
  },
  mounted() {
    document.addEventListener("click", (e) => {
      const navfree = document.getElementById("navfree");

      if (navfree) {
        if (!navfree.contains(e.target)) {
          this.isfree = false;
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  // background-color: skyblue;
}
@media screen and (min-width: 769px) and (max-width: 1200px) {
  // background-color: pink;
}
@media screen and (min-width: 1201px) and (max-width: 3800px) {
  .top_title {
    // width: 1200px;
    margin: 0 auto;
    position: relative;
    z-index: 99;

    .top_nav {
      width: 100%;
      margin: 0 auto;
      box-sizing: border-box;
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      // background: rgba(0, 0, 20,0.2);
      .logo {
        img {
          height: 40px;
        }
        span {
          margin-left: 5px;
        }
        .logo-style {
          display: flex;
          align-items: center;
          .logotop-main {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-bottom: 4px;
            > span:nth-child(1) {
              font-size: 19px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #fff;
            }
            > span:nth-child(2) {
              letter-spacing: 0.2px;
              margin-top: 4px;
              font-size: 12px;
              font-family: Arial;
              font-weight: 400;
              color: #fff;
            }
          }
        }
      }
      .navigation {
        display: flex;
        color: #fff;
        display: flex;
        align-items: center;
        li {
          cursor: pointer;
          padding: 20px;
          box-sizing: border-box;
          position: relative;
          ol {
          }
        }
        .nav-free {
          width: 100px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(9, 25, 50, 0.22);
          border: 1px solid rgba(255, 255, 255, 0.76);
          border-radius: 20px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          
          position: relative;
          .navfree-mask {
            width: 260px;
            // height: 200px;
            background: #fff;
            position: absolute;
            padding: 15px 10px;
            box-sizing: border-box;
            top: 40px;
            left: -150px;
            border-radius: 5px;
            .close-style {
              color: #000;
              display: flex;
              justify-content: flex-end;
              cursor: pointer;
            }
            .mask-content {
              width: 100%;

              display: flex;
              align-items: center;
              flex-direction: column;
              > img {
                width: 70%;
                height: auto;
              }
              > span {
                font-size: 12px;
                color: #b2aeae;
              }
            }
          }
        }
        .ol-style {
          .ol-main {
            background: linear-gradient(98deg, #3180f6, #55c3f2);
            font-family: PingFang SC;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 30px;
            color: #fff;
          }
          .olmian-style {
            font-size: 14px;
          }
          position: absolute;
          top: 46px;
          left: 5px;
          width: 100px;
          padding: 10px 0 0 0;
          text-align: center;
          line-height: 30px;
          display: none;
          font-size: 14px !important;
          // padding: 10px 10px;
          background: url("@/assets/image/newslices/navborder.png") no-repeat;
          > ol {
            line-height: 40px;
            font-size: 14px !important;
          }
          ol:hover {
            //  color: #FFFFFF !important;
            background: linear-gradient(98deg, #3180f6, #55c3f2);
          }
        }
        li:hover .ol-style {
          display: block;
        }
        li:hover {
          color: #05abfa;
        }
        .home-select:has(+ .nav-free) {
color: red;
}
        .home-select {
          // color: #05abfa;

          font-family: PingFang SC;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
          position: relative;
          .li-line {
            position: absolute;
            top: 50px;
            left: 22px;
            width: 60px;
            height: 2px;
            background: #ffffff;
          }
          .li-linehome {
            position: absolute;
            top: 50px;
            left: 16px;
            width: 40px;
            height: 2px;
            background: #ffffff;
          }
          // border-bottom: 1px solid #05abfa;
        }
        .home-select:hover {
          // color: #05abfa;
        }
        .home-noselect {
          color: #fff;
          font-family: PingFang SC;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
